import {
  Component, AfterViewInit, Renderer2, ElementRef,
  inject
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import LoginService from 'app/core/login/login.service';
import StateStorageService from 'app/core/auth/state-storage.service';
import IdleService from 'app/core/auth/idle.service';

@Component({
  selector: 'jhi-login-modal',
  templateUrl: './login.component.html'
})
export default class JhiLoginModalComponent implements AfterViewInit {
  authenticationError: boolean;

  private fb = inject(FormBuilder);

  loginForm = this.fb.group({
    username: [''],
    password: [''],
    rememberMe: [false]
  });

  constructor(
    private loginService: LoginService,
    private stateStorageService: StateStorageService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    public activeModal: NgbActiveModal,
    private idleService: IdleService
  ) {}

  ngAfterViewInit() {
    // setTimeout(() => this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#username'), 'focus', []), 0);
    setTimeout(
      () => this.elementRef.nativeElement
        .querySelector('#username' as any)?.focus.apply(this.elementRef.nativeElement.querySelector('#username'), []),
      0
    );
  }

  cancel() {
    this.authenticationError = false;
    this.loginForm.patchValue({
      username: '',
      password: ''
    });
    this.activeModal.dismiss('cancel');
  }

  login() {
    this.loginService
      .login({
        username: this.loginForm.get('username').value,
        password: this.loginForm.get('password').value,
        rememberMe: this.loginForm.get('rememberMe').value
      })
      .then(() => {
        this.authenticationError = false;
        this.idleService.checkUserIdle();
        this.activeModal.dismiss('login success');
        if (
          this.router.url === '/account/register' ||
          this.router.url.startsWith('/account/activate/') ||
          this.router.url.startsWith('/account/reset/')
        ) {
          this.router.navigate(['']);
        }

        // previousState was set in the authExpiredInterceptor before being redirected to login modal.
        // since login is successful, go to stored previousState and clear previousState
        const redirect = this.stateStorageService.getUrl();
        if (redirect) {
          this.stateStorageService.storeUrl(null);
          this.router.navigateByUrl(redirect);
        }
      })
      .catch(() => {
        this.authenticationError = true;
      });
  }

  register() {
    this.activeModal.dismiss('to state register');
    this.router.navigate(['/account/register']);
  }

  requestResetPassword() {
    this.activeModal.dismiss('to state requestReset');
    this.router.navigate(['/account/reset', 'request']);
  }
}
